import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eb57daa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top_header_plate" }
const _hoisted_2 = { class: "top_header_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"28px"} }, null, -1))


    import { useRouter } from "vue-router";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'TopHeader',
  props: ['title','isfilter','filterClick'],
  setup(__props) {

const props = __props;


    const router = useRouter();
    
    const goBack =()=> {
        router.go(-1);
    }
    const filter = ()=>{
       props.filterClick()
    }


return (_ctx: any,_cache: any) => {
  const _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_RefreshLeft = _resolveComponent("RefreshLeft")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [
          _createVNode(_component_ArrowLeftBold, { onClick: goBack })
        ]),
        _: 1
      }),
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1),
      (__props.isfilter == 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "center_flex_layout common_right_view",
            style: {"font-size":"14px"},
            onClick: filter
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Filter)
              ]),
              _: 1
            }),
            _createTextVNode("篩選 ")
          ]))
        : _createCommentVNode("", true),
      (__props.isfilter == 'update')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "center_flex_layout common_right_view",
            style: {"font-size":"14px"},
            onClick: filter
          }, [
            _createVNode(_component_el_button, {
              style: {"border-radius":"0"},
              type: "primary",
              plain: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_RefreshLeft)
                  ]),
                  _: 1
                }),
                _createTextVNode("刷新 ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_3
  ]))
}
}

})